module.exports = __webpack_public_path__ + "img/dialog.c4e2b93d.png";